module.exports = __webpack_public_path__ + "img/google-petra-02.4ca83715.jpg";